import { render, staticRenderFns } from "./SpecialSminoe202410.vue?vue&type=template&id=a84271e2"
import script from "./SpecialSminoe202410.vue?vue&type=script&lang=js"
export * from "./SpecialSminoe202410.vue?vue&type=script&lang=js"
import style0 from "./SpecialSminoe202410.vue?vue&type=style&index=0&id=a84271e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports